<script>
  // TODO: render checkbox and dropdown as same column
  export let isChecked = false;
  export let renderBy = "checkbox";
  export let isHeader = false;
</script>

<div class="flex justify-center align-center gap-2">
  {#if renderBy === "checkbox"}
    <input
      type="checkbox"
      class="focus:ring-yellow-500 h-5 w-5 text-yellow-600 border-gray-300"
      on:click
      checked={isChecked}
    />
  {/if}
  {#if renderBy === "dropdown"}
    <div class="flex flex-row justify-end align-center">
      {#if isHeader}
        <div>&nbsp; &nbsp;</div>
      {/if}
    </div>
  {/if}
</div>
